import {createAsyncThunk} from '@reduxjs/toolkit'
import {fetchIndividual} from 'sr/utils/api/individualApi'

interface UserData {
  id: string
  name: string
}

export const fetchUserData = createAsyncThunk(
  'user/fetchUserData',
  async (payload: any) => {
    // Single call instead of double-fetch pattern
    const response = await fetchIndividual({limit: 10000})

    const userMap: {[key: string]: {firstName: string; lastName: string}} = {}
    const userData: UserData[] = [] as UserData[]

    response.data.forEach((user: any) => {
      userMap[user.id || user._id] = {
        firstName: user.first_name,
        lastName: user.last_name,
      }
      userData.push({
        id: user.id || user._id,
        name: `${user.first_name} ${user.last_name}`,
      })
    })

    return {
      userMap,
      userData,
    }
  },
  {
    condition: (_payload, { getState }) => {
      const { user } = getState() as { user: { status: string } }
      return user.status !== 'succeeded' && user.status !== 'loading'
    },
  }
)
